/**
 * @returns {undefined | object}
 */
module.exports = function getForm1262ReturningUserData() {
    const form1262ReturningUserFormDataJson = localStorage.getItem("form1262ReturningUser");

    if (form1262ReturningUserFormDataJson) {
        try {
            return JSON.parse(form1262ReturningUserFormDataJson);
        } catch (e) {
            // Return undefined
        }
    }

    return undefined;
};